import React, {useState} from 'react';
import {Route, Routes, useNavigate} from 'react-router-dom';
import './index.css';
import Survey from "./components/Survey";
import Login from "./components/Login";
import Title from "./components/Title";
import Welcome from "./components/Welcome";

function App() {
  const [token, setUserToken] = useState();
  const [user, setUser] = useState();
  const [welcome, setWelcome] = useState({});
  const [isComplete, setIsComplete] = useState(false);

  const navigate = useNavigate();

  const handleLogout = (complete) => {
    localStorage.clear();
    setUserToken(null)

    if (complete === true) {
      setIsComplete(true);
    }
    if (complete !== true) {
      navigate("/haemotherapieNeu/login");
    }
  }

  const handleLogin = () => {
    setIsComplete(false)
    console.log(isComplete)
  }

  if (!token && !isComplete) {
    return (
      <div>
        <Title login={handleLogin}/>
        <Login setUserToken={setUserToken} setUser={setUser} setWelcome={setWelcome}/>
      </div>
    )
  }

  if (isComplete) {
    return (
      <div>
        <Title login={handleLogin}/>
        <div className="complete-page">
          <h2>Die Daten zum Qualitätsbericht Hämotherapie wurden erfolgreich an die Landesärztekammer übermittelt.<br /><br /> Vielen Dank!</h2>
        </div>
      </div>
    )
  }

  return (
    <div className="wrapper">
      <Title logout={handleLogout} token={token} user={user} login={handleLogin}/>
      <Routes>
        <Route exact path="/haemotherapieNeu" element={<Survey logout={handleLogout}/>}/>
        <Route exact path="/haemotherapieNeu/login"
               element={<Login setUserToken={setUserToken} setUser={setUser} setWelcome={setWelcome}/>}/>
        <Route exact path="/haemotherapieNeu/wilkommen"
               element={<Welcome welcomeData={welcome}/>}/>
      </Routes>
    </div>
  );
}

export default App;
